import { Carousel } from '@mantine/carousel'
import { Box } from '@mantine/core'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import React, { useRef } from 'react'
import CarouselItem from '../components/carousel_item'
import NextSmallSVG from './buttons/next_carousel_button_small'
import { useRouter } from 'next/router'
import PreviousSmallSVG from './buttons/previous_carousel_button_small'
import TitleDivider from './divider'

const TrendingItemsCard = ({ contentType, data }) => {
  const t = useTranslations('Contents')
  const { locale } = useRouter()

  // Función para obtener la traducción correcta según el tipo
  const getTypeTranslation = (type) => {
    return type === 'movie' ? t('moviesUppercase') : t('tvShowsUppercase')
  }

  // Función para obtener mes y año actual en inglés
  const getCurrentMonthAndYear = () => {
    const currentDate = new Date()
    const month = currentDate.toLocaleString(locale, { month: 'long' })
    const year = currentDate.getFullYear()
    return {
      month,
      year
    }
  }

  // Usar la traducción directamente con el formato correcto
  const { month, year } = getCurrentMonthAndYear()

  // Filtrar elementos que tienen backdrop
  const filteredItems = data.filter((item) => item.backdrop) || []

  // Autoplay referencia
  const autoplay = useRef(Autoplay({ delay: 3000 }))

  return (
    <Box mt={24}>
      <TitleDivider
        titleText={t('trendingNowWithDate', {
          type: getTypeTranslation(contentType),
          month: month.toUpperCase(),
          year
        })}
      />
      <Carousel
        height={130}
        width="100%"
        mt={12}
        mb={10}
        slideGap="xs"
        slideSize="26%"
        loop={false}
        align="start"
        slidesToScroll={4}
        nextControlIcon={<NextSmallSVG />}
        previousControlIcon={<PreviousSmallSVG />}
        plugins={[autoplay.current]}
        onMouseEnter={autoplay.current.stop}
        onMouseLeave={autoplay.current.reset}
        styles={{
          control: {
            opacity: 1,
            cursor: 'default',
            backgroundColor: 'transparent',
            border: 'transparent',
            transform: 'none',
            transition: 'none',

            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default',
              visibility: 'hidden',
              pointerEvents: 'none',
              width: 0,
              margin: 0
            },
            '@media (max-width: 768px)': {
              display: 'none'
            }
          }
        }}
      >
        {filteredItems.map((item, index) => {
          const poster = item.translation?.backdrop || item.backdrop
          const title = item.translation?.title || item.title
          // Crear una clave única combinando uid, tipo de contenido e índice
          const uniqueKey = `${item.uid}-${contentType}-${index}`
          return (
            <Carousel.Slide key={uniqueKey}>
              <CarouselItem
                posterUrl={poster}
                id={item.slug}
                num={index + 1}
                ranking={item?.ranking}
                year={item.year}
                genre={item.genre}
                title={title}
                type={contentType}
                hasUrl
                score={item.score}
              />
            </Carousel.Slide>
          )
        })}
      </Carousel>
    </Box>
  )
}

TrendingItemsCard.propTypes = {}

export default TrendingItemsCard
